module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-latin122.1391819.woff2";